import * as React from "react";
import { forwardRef } from "react";
const SvgNavigationCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M7.2 8 4.5 5.3l.8-.8L8 7.2l2.7-2.7.8.8L8.8 8l2.7 2.7-.8.8L8 8.8l-2.7 2.7-.8-.8L7.2 8z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgNavigationCross);
export { ForwardRef as ReactComponent };
